import { IWindowService } from 'angular';

StripeFactory.$inject = ['$window'];

// see: https://stripe.com/docs/stripe-js/v2
export function StripeFactory($window: IWindowService): stripe.StripeStatic {
    return $window.Stripe as stripe.StripeStatic;
}
